import React from 'react';
import ClientList from '../../Components/ClientList/ClientList';
import styles from './Clients.module.css';

const Clients = () => {
  return (
    <div className={styles.clientsView}>
      <ClientList />
    </div>
  );
};

export default Clients;